module.exports = __webpack_public_path__ + "52fda97ce0f3cbfac07626e56daead32.svg";